export enum LabelPrintTemplateType {
  Default = "Default",
  Bergstrom = "Bergstrom",
  Netcost = "Netcost"
}
